// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getVendorAddressApi } from "../../Service/Api/VendorAddressApi"
import { getVendorAddressList,getErrors } from "../Reducer/VendorAddressReducer"

 

// Watchers
function* vendorAddressSaga() {
	yield takeEvery("vendorAddress_list/getVendorAddress", getVendor)
}

// Sagas
function* getVendor(action) {
	// console.log(action)
	try {
		const getVendorAddress = yield call(getVendorAddressApi, action.payload)
		// console.log(getVendorAddress.status);
		if (getVendorAddress.request.status === 200) {
			yield put(getVendorAddressList(getVendorAddress))
			// console.log(getVendorAddress.status);
		} else {
			yield put(getErrors(getVendorAddress))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(vendorAddressSaga)])
}
